import React from 'react';
import styles from './SkeletonInfoPanel.module.scss';

const SkeletonInfoPanel = () => (
  <div className={styles.skeletonInfoPanel} />
);

export default SkeletonInfoPanel;
